import { configFetch as fetch } from '@laigu/utils';

// 名片字段
export const getAttrKeyApi = () => {
  return fetch({
    url: '/client/custom_field',
    method: 'get'
  }).then(res => {
    return (res.data && res.data.custom_attrs) || [];
  });
};

// 名片顺序
export const getAttrOrderApi = () => {
  return fetch({
    url: '/client/attr_order',
    method: 'get'
  }).then(res => {
    return (res.data && res.data.orders) || [];
  });
};

// 获取字段和顺序
export const getAttrSettingApi = () => {
  const promise1 = getAttrKeyApi();
  const promise2 = getAttrOrderApi();
  return Promise.all([promise1, promise2]).then(([customAttrs, attrOrders]) => {
    // 数据顺序
    // 非delete 并且visitble为true 添加属性visible为true
    // 非delete 并且visitble为false 添加属性visible为false
    // delete 数据
    let orderedAttrs = [];
    attrOrders.forEach(ao => {
      const attr =
        customAttrs[
          customAttrs.findIndex(ca => {
            return ca.name === ao.attr_name && !ca.deleted;
          })
        ];
      if (attr && ao.visible) {
        attr.visible = true;
        orderedAttrs.push(attr);
      }
    });
    attrOrders.forEach(ao => {
      const attr =
        customAttrs[
          customAttrs.findIndex(ca => {
            return ca.name === ao.attr_name && !ca.deleted;
          })
        ];
      if (attr && !ao.visible) {
        attr.visible = false;
        orderedAttrs.push(attr);
      }
    });
    const deletedAttrs = customAttrs.filter(ca => {
      return ca.deleted;
    });
    orderedAttrs = orderedAttrs.concat(deletedAttrs);
    return orderedAttrs || [];
  });
};
// 名片内容
export const getAttrsApi = trackId => {
  return fetch({
    url: `/client/${trackId}/attrs`,
    method: 'get'
  });
};
// 更新顾客字段
export const updateVisitorAttrsApi = ({ trackId, convId, visitId, attrs }) => {
  return fetch({
    url: `/client/${trackId}/attrs`,
    method: 'post',
    data: {
      conv_id: convId || null,
      visit_id: visitId || null,
      attrs
    }
  });
};

// 获取黑名单 (单个用data: {track_id: xxx}，多个用复杂的筛选条件)
export const getBlacklistApi = ({ trackId }) => {
  return fetch({
    url: '/agent/visit/blacklist',
    method: 'get',
    params: {
      track_id: trackId
    }
  }).then(res => {
    return (res && res.data) || [];
  });
};

export const getBlacklistSingleApi = ({ trackId }) => {
  return fetch({
    url: `/agent/visit/blacklisting_info/${trackId}`,
    method: 'get'
  }).then(res => {
    return (res && res.data) || [];
  });
};

// 添加黑名单
export const addBlacklistApi = ({ trackId, visitId, convId }) => {
  return fetch({
    url: '/agent/visit/blacklist',
    method: 'PUT',
    data: {
      track_id: trackId,
      visit_id: visitId,
      conv_id: convId
    }
  });
};

// 移除黑名单
export const removeBlacklistApi = ({ trackId }) => {
  return fetch({
    url: '/agent/visit/blacklist',
    method: 'delete',
    data: {
      track_ids: [trackId]
    }
  });
};

// 获取顾客管理用户配置
export const getCustomerUserConfig = entId => {
  return fetch({
    url: `/users/config`,
    params: { entId }
  });
};

// 获取顾客名片配置
export const getAttrConfig = params => {
  return fetch({
    url: `/users/attr_config`,
    params
  });
};

export const editAttrConfig = params => {
  const { attId, ...otherParams } = params;
  return fetch({
    url: `/users/attr_config/${attId}`,
    method: 'put',
    data: otherParams
  });
};

export const addAttrConfig = params => {
  return fetch({
    url: `/users/attr_config/`,
    method: 'post',
    data: params
  });
};

export const getCustomerQueryParams = entId => {
  return fetch({
    url: `/users/segments`,
    params: { entId }
  });
};

export const addCustomerQueryParams = data => {
  return fetch({
    url: `/users/segments/v2`,
    method: 'POST',
    data
  });
};

export const deleteCustomerQueryParams = id => {
  return fetch({
    url: `/users/segments/${id}`,
    method: 'DELETE'
  });
};

export const editCustomerQueryParams = data => {
  const { id, ...otherData } = data;
  return fetch({
    url: `/users/segments/v2/${id}`,
    method: 'PUT',
    data: otherData
  });
};

export const getCustomerList = data => {
  return fetch({
    url: `/unified-api/crm/v1/users/search/v3`,
    method: 'POST',
    data
  });
};

export const getCustomerAttrs = params => {
  return fetch({
    url: `client/${params}/attrs`
  });
};

export const exportCustomer = data => {
  return fetch({
    url: `/unified-api/crm/v1/users/export/v4`,
    method: 'POST',
    data
  });
};

export const checkExportCustomerStatus = () => {
  return fetch({
    url: `/users/export_status`
  });
};

export const deleteCustomer = data => {
  return fetch({
    url: `/users/batch`,
    method: 'DELETE',
    data
  });
};

export const getCustomerDetail = params => {
  return fetch({
    url: `/users/${params}/detail_msg/v2`
  });
};

export const editCustomerName = data => {
  const { visitId, ...otherData } = data;
  return fetch({
    url: `/visit/${visitId}`,
    method: 'PUT',
    data: otherData
  });
};

export const editCustomerInfo = data => {
  const { trackId, ...otherData } = data;
  return fetch({
    url: `client/${trackId}/attrs`,
    method: 'POST',
    data: otherData
  });
};

export const addCustomerTag = data => {
  const { trackId, ...otherData } = data;
  return fetch({
    url: `/agent/client/${trackId}/user/tags`,
    method: 'POST',
    data: otherData
  });
};

export const deleteCustomerTag = data => {
  const { trackId, tagId, ...otherData } = data;
  return fetch({
    url: `/agent/client/${trackId}/user/tags/${tagId}`,
    method: 'DELETE',
    data: otherData
  });
};

export const getCustomerTimeline = params => {
  const { trackId, ...otherParams } = params;
  return fetch({
    url: `/client/${trackId}/timeline`,
    params: otherParams
  });
};

export const getChangeLogList = params => {
  const { trackId, ...otherParams } = params;
  return fetch({
    url: `/client/${trackId}/attr_change_logs`,
    params: otherParams
  });
};

export const getCustomerPages = ({ visitId, trackId }) => {
  return fetch({
    url: `/visit/${visitId}/pages`,
    params: { track_id: trackId }
  });
};

export const getTrackEventList = params => {
  const { trackId, ...otherParams } = params;
  return fetch({
    url: `/client/${trackId}/client_events`,
    params: otherParams
  });
};

export const getTrackEventSettingList = () => {
  return fetch({
    url: `/client/client_events/fields`
  });
};

export const getTrackEventDetail = params => {
  return fetch({
    url: `/client/client_events/${params}`
  });
};

export const editTrackEventSetting = params => {
  const { fieldId, ...otherPrams } = params;
  return fetch({
    url: `/client/client_events/fields/${fieldId}`,
    method: 'PUT',
    params: otherPrams
  });
};
